<template>
    <div style="margin: auto; width: 450px">
        <div style="margin-left: 10px; display: flex; align-items: center">
            <el-image style="width: 50px; height: 50px" :src="chooseItem.img" ></el-image>
            <span style="margin-left: 10px; margin-top: auto; margin-bottom: auto">
                <b>{{ chooseItem.crafite_name }}</b>
                <a v-if="chooseItem.language == 1">English</a>
                <a v-else>Spanish</a>
            </span>
        </div>
        <div>
            <el-form align="left" size="small" :rules="rules" :model="formData" ref="formData" :validate-on-rule-change="false">
                <el-form-item align="left" prop="show_charter_no" label="Charter No:">
                    <el-input type="number" min="1" style="width: 100px" class="el-input--small" v-model="formData.show_charter_no"></el-input>
                </el-form-item>

                <el-form-item align="left" label="Audio file:" prop="file">
                    <audio v-if="audio_src != ''" style="width: 200px" :src="audio_src" controls class="float-left"/>
                    <label style="margin-left: 20px; width: 100px" class="float-left btn-block re-upload-img-btn">
                        upload audio
                        <input ref="file" accept="audio/mp3" type="file" @change="setAudio('file')" class="re-upload-img"/>
                    </label>
                </el-form-item>
                <el-form-item align="left" prop="audio_name" label="Audio Name:">
                    <el-input style="width: 50%" v-model="formData.audio_name"></el-input>
                </el-form-item>
                <div v-if="isQA == 1">
                    <!-- QA -->
                    <el-form-item><b>Q&A</b></el-form-item>
                    <el-form-item align="left" style="">
                        <el-form-item style="display: flex" label="Enable:">
                            <el-switch size="small" @change="switchChange('QA')" :value="enable" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                        </el-form-item>
                        <el-form-item :hidden="!enable" prop="options" style="display: flex" label="Operations:">
                            <el-checkbox-group :disabled="!enable" v-model="formData.options">
                                <el-checkbox label="1">Yellow</el-checkbox>
                                <el-checkbox label="2">Red</el-checkbox>
                                <el-checkbox label="3">Green</el-checkbox>
                                <el-checkbox label="4">Blue</el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                        <el-form-item :hidden="!enable" prop="QA" style="display: flex; margin: 0px; padding: 0px" label="Current button:">
                            <el-radio-group :disabled="!enable" v-model="formData.QA">
                                <el-radio :label="1">Yellow</el-radio>
                                <el-radio :label="2">Red</el-radio>
                                <el-radio :label="3">Green</el-radio>
                                <el-radio :label="4">Blue</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item hidden prop="active" style="display: flex" label="Activate:">
                            <el-checkbox-group :disabled="!enable" v-model="formData.active">
                                <el-checkbox label="1">Yellow</el-checkbox>
                                <el-checkbox label="2">Red</el-checkbox>
                                <el-checkbox label="3">Green</el-checkbox>
                                <el-checkbox label="4">Blue</el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                    </el-form-item>

                    <!-- CE -->
                    <el-form-item><b>Content Engagement</b></el-form-item>
                    <el-form-item style="display: flex" label="Enable:">
                        <el-switch size="small" @change="switchChange('CE')" :value="ceEnable" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                    </el-form-item>
                    <div v-if="ceEnable">
                        <el-form-item label="Interaction Buttons:"></el-form-item>
                        <div v-for="(item, idx) in ceButtons" :key="item.name" style="display: flex;height: 55px; align-items: center">
                            <el-checkbox v-model="item.check" @change="ceCheckbox()" style="width: 80px;">{{item.name}}</el-checkbox>
                            <div v-if="item.check" style="display:flex;align-items: center">
                                <audio v-if="item.audio_src != ''" :src="item.audio_src" controls style="width: 220px" />
                                <label style="margin-left: 20px; width: 100px" class="btn-block re-upload-img-btn">
                                    upload audio
                                    <input :ref="item.name" accept="audio/mp3" type="file" @change="setAudio(item.name, idx)"  class="re-upload-img"/>
                                </label>
                            </div>
                        </div>
                    </div>

                </div>
                <el-form-item align="right">
                    <el-button style="" class="el-button--small el-button--default" @click="back()">Back</el-button>
                    <el-button style="" class="el-button--small el-button--primary" @click="submit('formData')">Save</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
export default {
    name: "CraftiesContentCreate",
    props: {
        isQA: Number,
    },
    data() {
        return {
            types: [
                { id: 0, label: "General" },
                { id: 1, label: "Q&A" },
                { id: 2, label: "My Crafite" },
                { id: 3, label: "Memery Game" },
                { id: 4, label: "Book" },
                { id: 5, label: "Funfact" },
            ],
            enable: false,
            ceEnable: false,
            flag: false,
            audio_src: "",
            is_qa: 0,
            buttonIDs: [],
            ceButtons: [
                {name: "Yellow", value:'1', id: 0, check: false, audio_src: '', file: null},
                {name: "Red", value:'2', id: 0, check: false, audio_src: '', file: null},
                {name: "Green", value:'3', id: 0, check: false, audio_src: '', file: null},
                {name: "Blue", value:'4', id: 0, check: false, audio_src: '', file: null},
            ],
            formData: {
                charter_no: "",
                show_charter_no: "",
                file: "",
                active: [],
                options: [],
                QA: 0,
                audio_name: "",
                audio_url: "",
            },
            chooseItem: {},
            chooseItem1: {},
            ceCounts: {},
            listLength: 0,
            rules: {
                show_charter_no: [
                    { required: true, message: "Please enter charter_no!" },
                    {
                        validator: (rule, value, callback) => {
                            if (value < 1) {
                                callback(new Error(`Charter No minimum value is 1.`));
                            }
                            if (value > this.listLength) {
                                callback(new Error(`Charter No MAX value is ${this.listLength}.`));
                            }
                            callback();
                        },
                    },
                ],
                QA: [
                    {
                        validator: (rule, value, callback) => {
                            this.formData.options.push(value + "");
                            callback();
                        },
                    },
                ],
            },
        };
    },
    created() {
        this.chooseItem = this.$util.fetch("item");
        this.chooseItem1 = this.$util.fetch("item1");
        this.formData = this.$util.fetch("item1");
        this.ceCounts = this.$util.fetch("ceCounts");
        this.listLength = this.$util.fetch("listlength");

        this.formData.show_charter_no += "";
        this.is_qa = this.formData.QA != 0 ? 1 : 0;
        // 延时设值，不然会switch会冲突
        setTimeout(()=>{
            this.enable = (this.formData.QA > 1 && this.formData.QA < 5);
        },200)
        this.ceEnable = this.formData.QA == 8;
        this.audio_src = this.formData.audio_url;

        // active 数据
        const active = this.formData.active.split('');
        this.formData.active = [];

        for (let i = 0; i < active.length; i++) {
            if(active[i]=='1'){
                this.formData.active.push((i+1)+'')
            }
        }

        // options 数据
        const options = this.formData.options.split('');
        this.formData.options = [];
        if (this.formData.QA > 0){
            for (let i = 0; i < options.length; i++) {
                if(options[i]=='1'){
                    this.formData.options.push((i+1)+'')
                }
            }
        }

        // ceButtons 数据
        if (this.formData.ceButtons){
            this.formData.ceButtons.forEach((item,idx)=>{
                this.ceButtons[idx].check = item.status==1
                this.ceButtons[idx].id = item.id;
                this.ceButtons[idx].audio_src = item.audio_url;
            })
        }
    },
    methods: {
        ceCheckbox(){
            const list = this.ceButtons.filter((item)=>item.check).map((item) => item.value)
            this.formData.options = list;
        },
        switchChange(type){
            this.ceButtons.map((item) => item.check = this.formData.options.indexOf(item.value) >= 0)
            if (type === "QA"){
                this.enable = !this.enable;
                // 延时设值，不然会switch会冲突
                setTimeout(() => {
                    this.ceEnable = false;
                }, 100);
            }else{
                this.ceEnable = !this.ceEnable;
                // 延时设值，不然会switch会冲突
                setTimeout(() => {
                    this.enable = false;
                }, 100);
            }
        },
        setAudio(refName, idx) {
            let loading = this.$util.loading();
            if (refName == 'file') {
                if (this.audio_src != "") {
                    window.URL.revokeObjectURL(this.audio_src);
                }
                this.audio_src = this.getObjectURL(this.$refs['file'].files[0]);
                this.formData.file = this.$refs['file'].files[0];
                this.$refs['file'].value = "";
                loading.close();
                return
            }
            if (this.ceButtons[idx].audio_src != "") {
                window.URL.revokeObjectURL(this.ceButtons[idx].audio_src);
            }
            this.ceButtons[idx].audio_src = this.getObjectURL(this.$refs[refName][0].files[0]);
            this.ceButtons[idx].file = this.$refs[refName][0].files[0];
            this.$refs[refName][0].value = "";
            loading.close();
        },
        getObjectURL(file) {
            let url = null;
            /* window.URL = window.URL || window.webkitURL;*/
            if (window.createObjcectURL != undefined) {
                url = window.createOjcectURL(file);
            } else if (window.URL != undefined) {
                url = window.URL.createObjectURL(file);
            } else if (window.webkitURL != undefined) {
                url = window.webkitURL.createObjectURL(file);
            }
            return url;
        },
        submit(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    this.$message.error("Please check the entered parameters!");
                    return
                }
                if ( this.formData.QA != 0 && this.formData.options.indexOf(this.formData.QA + "") == -1 ) {
                    return this.$message.error("The correct answer must be an option!");
                }
                const checkIdx = this.ceButtons.findIndex((item)=>{ return item.check })
                const nofileIdx = this.ceButtons.findIndex((item)=>{ return item.check && (!item.file && item.audio_src == '') })
                if (this.ceEnable) {
                    if (checkIdx < 0){
                        return this.$message.error("Interaction Buttons must select one!");
                    }
                    if(nofileIdx >= 0){
                        return this.$message.error("Interaction Buttons must have file!");
                    }
                }

                const currentIdx = this.chooseItem1.show_charter_no;
                const toIdx =parseInt(this.formData.show_charter_no);
                let charter_no = this.formData.charter_no;
                if (currentIdx > toIdx) {
                    // 上移
                    charter_no = this.ceCounts[toIdx-1].front * 4 + toIdx
                } else if (currentIdx < toIdx) {
                    charter_no = this.ceCounts[toIdx-1].back * 4 + toIdx
                }

                let params = new FormData();
                params.append("crafite_uuid", this.chooseItem.crafite_uuid);
                params.append("charter_no", charter_no);
                params.append("audio_name", this.formData.audio_name);
                params.append("audio_id", this.formData.audio_id);
                params.append("languageCode",this.chooseItem.language == 2 ? "ES": "EN");
                let qa = 0;
                if (this.enable) {
                    qa = this.formData.QA;
                } else if (this.ceEnable){
                    qa = 8;
                }
                params.append("QA", qa);
                params.append("active", qa != 0 ? this.getValue(this.formData.active) : "0000");
                params.append("options", qa != 0 ? this.getValue(this.formData.options) : "0000");

                let haveAudioFile = 0;
                let position = [];
                if (this.formData.file) {
                    haveAudioFile = 1
                    position.push(0)
                    params.append("file", this.formData.file);
                }
                params.append("haveAudioFile",haveAudioFile)
                if (qa == 8){
                    for (let i = 0; i < this.ceButtons.length; i++) {
                        const item = this.ceButtons[i]
                        if(item.check && item.file){
                            position.push(parseInt(item.value))
                            params.append("file", item.file);
                        }
                    }
                }
                params.append("ce_position",position)

                let loading = this.$util.loading();
                this.$api.rootV1.post(
                    "/web/playlist/audio/editor",
                    params,
                    (res) => {
                        this.$alert("Successfully modified!", "info", {
                            confirmButtonText: "confirm",
                            type: "success",
                            callback: (action) => { loading.close(); },
                        });
                        this.$emit("closeUpdate", true);
                    },
                    (res) => {
                        this.$alert(`fail to modified!${res.errmsg}`, "info", {
                            confirmButtonText: "confirm",
                            type: "error",
                            callback: (action) => {
                                loading.close();
                                this.$emit("closeUpdate", true);
                            },
                        });
                    }
                );
                
            });
        },
        getValue(formDataActive) {
            let active = [];
            active.push(formDataActive.indexOf("1") > -1 ?'1':'0');
            active.push(formDataActive.indexOf("2") > -1 ?'1':'0');
            active.push(formDataActive.indexOf("3") > -1 ?'1':'0');
            active.push(formDataActive.indexOf("4") > -1 ?'1':'0');
            return active.join("");
        },
        back() {
            this.$emit("closeUpdate", this.flag);
        },
    },
    watch: {
        is_qa: function (newData, oldData) {
            console.log(newData);
            if (newData == 1) {
                this.enable = true;
            } else {
                this.enable = false;
                this.formData.QA = 0;
                this.formData.active = [];
                this.formData.options = [];
                this.formData.active = [];
            }
        },
    },
};
</script>

<style scoped>
    .el-form-item {
        padding: 0px;
    }

    .activation {
        border: none;
        background: none;
        margin-left: 5px;
        color: deepskyblue;
        text-decoration: underline deepskyblue; 
    }

    .re-upload-img-btn {
        position: relative;
        overflow: hidden;
        height: 35px;
        line-height: 35px;
        margin: 0;
        background-color: #409eff;
        text-align: center;
        color: #fff;
        font-size: 14px;
        border-radius: 4px;
        cursor: pointer;
        font-weight: 400;
    }

    .re-upload-img-btn:hover {
        background: #66b1ff;
    }

    .re-upload-img {
        visibility: hidden;
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/main/crafties/CraftiesContentUpdate.vue